import { IQueryParameterToolSet } from "../typings/queryParameterTools";

export class QueryParameterToolSet implements IQueryParameterToolSet {
    private static _instance: IQueryParameterToolSet;

    private constructor() {
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    get(queryString: string): Object {
        if (!queryString) {
            queryString = window.location.search;
        }

        const parameters: Object = {};
        if (queryString && queryString.length) {
            const query = queryString[0] === "?" ? queryString.substring(1) : queryString;
            const vars = query.split("&");
            for (let i = 0; i < vars.length; i++) {
                if (vars[i]) {
                    const pair = vars[i].split("=");
                    if (pair[0]) {
                        parameters[pair[0]] = pair[1] ? pair[1] : "";
                    }
                }
            }
        }

        return parameters;

    }

    append(paramName: string, paramValue: string, queryString: string): string {
        const parameters: Object = this.get(queryString);

        parameters[paramName] = paramValue;

        let newQuery = "?";
        let connector = "";
        for (const key in parameters) {
            if (parameters.hasOwnProperty(key)) {
                newQuery += (connector + key + "=" + parameters[key]);
                connector = "&";
            }
        }

        return newQuery;
    }
}

QueryParameterToolSet.instance;
